import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from './useDictionary';

export const useUpdatePersonalDetailsDictionary = () => {
  return useDictionary(Dictionary, DICTIONARY.UpdatePersonalDetails);
};
